<template>
  <div id="adminPaginas">
    <vue-headful title="Admin" lang="en" />
    <div v-if="criar">
      <div class="form-group">
        <label for="titulo">Language</label>
        <select v-model="form.language" class="form-control" id="lingua">
          <option :value="dt" v-for="(dt, index) in linguas" :key="index">{{pais(dt)}}</option>
        </select>
      </div>

      <div class="form-group">
        <div class="p-l-10">
          <div>
            <input :disabled="editMode" type="radio" v-model="link" value="0" @change="onChangeLink($event)">
            <label for="slug">Slug (without spaces)</label>
          </div>
          <div>
            <input :disabled="editMode" type="radio" v-model="link" value="1" @change="onChangeLink($event)">
            <label for="external_link">External link</label>
          </div>
        </div>
        <div>
          <input v-model="form.slug" v-if="link == 0" :disabled="!slugExists || this.editMode" type="text" class="form-control" id="slug" aria-describedby="sluglHelp" placeholder="Slug">
          <input v-model="form.external_link" v-if="link == 1" type="text" class="form-control" id="external_link" aria-describedby="external_linkHelp" placeholder="External link">
        </div>
      </div>
      <div class="form-group">
        <label for="titulo">Title</label>
        <input v-model="form.title" type="text" class="form-control" id="titulo" aria-describedby="titulolHelp" placeholder="">
      </div>
      <div class="form-group" v-if="link == 0">
        <label for="titulo">Subtitle</label>
        <input v-model="form.subtitle" type="text" class="form-control" id="subtitulo" aria-describedby="subtitulolHelp" placeholder="">
      </div>
      <div class="form-group" v-if="link == 0">
        <label for="conteudo">Content</label>
        <vue-editor :disabled="link == 1" id="editor" useCustomImageHandler @image-added="handleImageAdded" v-model="form.content"></vue-editor>
      </div>

      <div class="form-group" v-show="form.noticias">
        <label for="capa">Vover Image</label>
        <br />
        <label for="file-upload1233" class="custom-file-upload">
          <i class="fa fa-cloud-upload"></i> Upload
        </label>
        <input id="file-upload1233" type="file" value="" @change.prevent.stop="onFileChange($event)">
        <div class="text-center margin-top-10" v-if="form.capa">
          <img :src="'/images/' + form.capa" class="m-h-100" />
          <br />
          <button class="btn btn-pure text-danger margin-top-10 m-t-10" @click="form.capa = ''"><i class="fas fa-trash margin-right-5"></i></button>
        </div>
      </div>
      <div class="form-check">
        <div class="row">
          <div class="col-md-2 col-lg-2 col-xs-6 col-sm-3">
            <input :disabled="link == 1" v-model="form.menu" type="checkbox" class="form-check-input" id="menuTop" @change="form.order_menu = !form.menu ? 0 : form.order_menu">
            <label class="form-check-label" for="menuTop">Menu Top</label>
          </div>
          <div class="col-md-2 col-lg-2 col-xs-6 col-sm-3">
            <label class="form-check-label" for="orderTop">Ordering</label>
            <input :disabled="!form.menu" v-model.number="form.order_menu" type="number" class="form-control" id="orderTop">
          </div>
        </div>
      </div>
      <div class="form-check">
        <div class="row">
          <div class="col-md-2 col-lg-2 col-xs-6 col-sm-3">
            <input v-model="form.footer_top" type="checkbox" class="form-check-input" id="footerTop" @change="form.order_footer1 = !form.footer_top ? 0 : form.order_footer1">
            <label class="form-check-label" for="footerTop">Menu Footer 1</label>
          </div>
          <div class="col-md-2 col-lg-2 col-xs-6 col-sm-3">
            <label class="form-check-label" for="order">Ordering</label>
            <input :disabled="!form.footer_top" v-model.number="form.order_footer1" type="number" class="form-control" id="order" >
          </div>
        </div>
      </div>
      <div class="form-check">
        <div class="row">
          <div class="col-md-2 col-lg-2 col-xs-6 col-sm-3">
            <input v-model="form.bottom" type="checkbox" class="form-check-input" id="menuFooter" @change="form.order_footer2 = !form.bottom ? 0 : form.order_footer2">
            <label class="form-check-label" for="menuFooter">Menu Footer 2</label>
          </div>
          <div class="col-md-2 col-lg-2 col-xs-6 col-sm-3">
            <label class="form-check-label" for="order">Ordering</label>
            <input :disabled="!form.bottom" v-model.number="form.order_footer2" type="number" class="form-control" id="order">
          </div>
        </div>
      </div>
      <div class="form-check">
        <input :disabled="link == 1" v-model="form.noticias" type="checkbox" class="form-check-input" id="noticias">
        <label class="form-check-label" for="noticias">News</label>
      </div>
      <div class="form-check">
        <input v-model="form.active" type="checkbox" class="form-check-input" id="estado">
        <label class="form-check-label" for="estado">Active</label>
      </div>
      <br />
      <button type="button" @click="criar = 0" class="btn btn-default float-left">CANCEL</button>
      <button v-if="form.id" type="button" @click="submit" class="btn btn-primary float-right">UPDATE</button>
      <button v-else type="button" @click="submit" class="btn btn-primary float-right">SAVE</button>
      <div class="clearfix"></div>
      <div class="text-center">
        <a v-if="form.bloqueado > 0" class="mao text-danger" @click="apagar(form, formIndex)">DELETE PAGE</a>
      </div>
    </div>

    <div v-else>
      <h3>Search</h3>
      <div>
        <div class="form-group">
          <label for="searchText">Title / Subtitle / Slug</label>
          <input type="text" v-model="search.title" class="form-control" id="searchText" placeholder="">
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="lingua">Language</label>
            <select v-model="search.language" class="form-control" id="lingua">
              <option :value="dt" v-for="(dt, index) in linguas" :key="index">{{pais(dt)}}</option>
            </select>
          </div>
          <div class="form-group col-md-6">
            <label for="searchType">Option</label>
            <select v-model="search.type" class="form-control" id="searchType">
              <option value="menu">Menu Top</option>
              <option value="footer_top">Menu Footer 1</option>
              <option value="bottom">Menu Footer 2</option>
              <option value="news">News</option>
              <option value="active">Active</option>
            </select>
          </div>
        </div>
        <button @click="searchFN(1)" class="btn btn-primary float-right">Search</button>
      </div>
      <div class="clearfix"></div>
      <br />
      <hr />
      <br />
      <div class="row" style="justify-content: end">
        <div class="col-md-3 col-lg-3 col-xs-6 col-sm-6">
          <button class="btn btn-block btn-primary m-b-10" @click="editar()">Create Page</button>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-bordered dataTable" id="dataTable" width="100%" cellspacing="0" role="grid" aria-describedby="dataTable_info">
          <thead>
            <tr role="row">
              <th class="w-41"></th>
              <th class="w-41"></th>
              <th class="w-41"></th>
              <th>Title</th>
              <th>Slug</th>
              <th>Order in Menu</th>
              <th>Order in Footer1</th>
              <th>Order in Footer2</th>
              <th class="w-110"></th>
            </tr>
          </thead>
          <tbody v-if="res[0]">
            <tr v-for="(dt, index) in res" :key="index">
              <td class="text-center"><i v-if="dt.active" class="fas fa-certificate text-success"></i></td>
              <th><i v-if="dt.type == 'news'" class="fas fa-newspaper"></i></th>
              <th v-html="pais(dt.language, 1)"></th>
              <td>{{dt.title}}</td>
              <td>{{dt.slug}}</td>
              <td>{{dt.order_menu}}</td>
              <td>{{dt.order_footer1}}</td>
              <td>{{dt.order_footer2}}</td>
              <td class="text-center no-wrap p-0">
                <button class="btn btn-pure m-h-5" @click="editar(dt, index)"><i class="fas fa-edit"></i></button>
                <button :disabled="dt.bloqueado > 0" class="btn btn-pure m-h-5 text-danger" @click="apagar(dt, index)"><i class="fas fa-trash"></i></button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <td colspan="6">
              <div class="alert alert-danger m-v-50" role="alert">No results.</div>
            </td>
          </tbody>
        </table>
      </div>

      <nav class="float-right">
        <ul class="pagination">
          <li class="page-item" v-if="pag > 1">
            <router-link class="page-link" to="1" @click="searchFN(1)" aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
            </router-link>
          </li>
          <li v-if="pag - 2 > 1" class="page-item"><router-link class="page-link" :to="pag - 2" @click="searchFN(pag - 2)">{{pag - 2}}</router-link></li>
          <li v-if="pag - 1 > 1" class="page-item"><router-link class="page-link" :to="pag - 1" @click="searchFN(pag - 1)">{{pag - 1}}</router-link></li>
          <li class="page-item active"><a class="page-link">{{pag}}</a></li>
          <li v-if="parseInt(pag) + 1 < last_page" class="page-item"><router-link class="page-link" :to="parseInt(pag) + 1" @click="searchFN(parseInt(pag) + 1)">{{parseInt(pag) + 1}}</router-link></li>
          <li v-if="parseInt(pag) + 2 < last_page" class="page-item"><router-link class="page-link" :to="parseInt(pag) + 2" @click="searchFN(parseInt(pag) + 2)">{{parseInt(pag) + 2}}</router-link></li>
          <li v-if="parseInt(pag) + 3 < last_page" class="page-item"><router-link class="page-link" :to="parseInt(pag) + 3" @click="searchFN(parseInt(pag) + 3)">{{parseInt(pag) + 2}}</router-link></li>
          <li class="page-item" v-if="pag < last_page">
            <router-link class="page-link" :to="last_page" @click="searchFN(last_page)" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
    <div id="editor"></div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import PAISES from './../components/paises.json'
import { VueEditor } from 'vue2-editor'
import myMixin from '../mixnin'
/*
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'

Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)
*/

export default {
  components: { VueEditor },
  name: 'adminPaginas',
  data () {
    return {
      search: {
        title: '',
        type: '',
        language: ''
      },
      res: [],
      formIndex: '',
      form: {
        title: '',
        slug: '',
        external_link: null,
        active: true,
        menu: true,
        bottom: true,
        footer_top: false,
        content: '',
        id: '',
        noticias: false,
        capa: '',
        language: 'GB'
      },
      paises: PAISES,
      linguas: ['GB'],
      criar: false,
      pag: 1,
      total: 0,
      last_page: 1,
      editorSettings: {
        modules: {
          imageDrop: true,
          imageResize: {}
        }
      },
      sitemapContent: {},
      sitemapContentExists: false,
      slugExists: false,
      link: '0',
      editMode: false,
      tableKey: 0
    }
  },
  mixins: [myMixin],
  mounted () {
    this.SET_LOAD(true)
    this.SET_TITULO('Pages')
    this.pag = this.$route.params.id
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_TITULO',
      'SET_LOAD',
      'SET_LOAD1',
      'SET_TOAST',
      'SET_AVISO'
    ]),
    init () {
      if (this.$store.state.option1 && this.$store.state.user1) {
        if (!(this.$store.state.user.role)) {
          this.$router.push('/', () => {})
          return
        }
        this.linguas = JSON.parse(this.$store.state.option.langs)
        this.form.language = this.$store.state.lang
        this.form.external_link = this.link === '1' ? 'http://' : null
        this.form.menu = this.link === '1' ? 0 : 1
        this.SET_LOAD()
        this.SET_LOAD1(true)
        this.searchFN(this.pag)
        // get sitemap.xml and parse it to json
        this.getSitemapJson(this)
      } else {
        this._.delay(this.init, 100)
      }
    },
    searchFN (pag) {
      let search = ''
      if (this.search.title) {
        search += '&title=' + this.search.title + '&subtitle=' + this.search.title + '&slug=' + this.search.title
      }
      if (this.search.language) {
        search += '&language=' + this.search.language
      }
      if (this.search.type === 'menu') {
        search += '&menu=1'
      }
      if (this.search.type === 'news') {
        search += '&type=1'
      }
      if (this.search.type === 'bottom') {
        search += '&bottom=1'
      }
      if (this.search.type === 'active') {
        search += '&active=1'
      }
      if (this.search.type === 'footer_top') {
        search += '&footer_top=1'
      }
      this.axios.get('/pages?page=' + (pag || 1) + search).then((res) => {
        this.criar = false
        this.total = res.data.total
        this.last_page = res.data.last_page
        this.res = res.data.data
        this.SET_LOAD1()
      }, (er) => {
        this.SET_AVISO(er.response.data.error)
      })
    },
    submit () {
      this.SET_LOAD1(true)
      if (this.form.noticias) {
        this.form.type = 'news'
      } else {
        this.form.type = 'page'
      }
      if (this.form.id) {
        if (this.validateOnSave('edit')) {
          this.axios.patch('/pages', this.form).then((res) => {
            let i = this.res.length
            while (--i >= 0) {
              if (this.form.id === this.res[i].id) {
                this.res.splice(i, 1)
                break
              }
            }
            // update sitemap
            if (!this.form.external_link) {
              this.submitSitemapChanges(this.parseJsonToXml(this.addFieldSitemap(this.sitemapContent, res.data)))
            }
            // finish update sitemap
            this.res.unshift(res.data)
            this.refresh()
            this.SET_LOAD1()
            this.SET_TOAST({ msg: 'Updated successfully' })
            this.criar = 0
            this.link = '0'
            this.SET_TITULO('Pages')
          }, (er) => {
            this.SET_AVISO(er.response.data.message)
          })
        }
      } else {
        // validations:
        if (this.validateOnSave('create')) {
          this.axios.post('/pages', this.form).then((res) => {
            // update sitemap
            this.res.unshift(res.data)
            if (!this.form.external_link) {
              this.submitSitemapChanges(this.parseJsonToXml(this.addFieldSitemap(this.sitemapContent, res.data)))
            }
            // finish update sitemap
            this.tableKey = Math.ceil(Math.random() * 99999)
            this.refresh()
            this.SET_LOAD1()
            this.SET_TOAST({ msg: 'Successfully created' })
            this.criar = 0
            this.link = '0'
            this.SET_TITULO('Pages')
          }, (er) => {
            this.SET_AVISO(er.response.data.message)
          })
        }
      }
    },
    validateOnSave (editOrCreate) {
      if (!this.form.title) {
        this.SET_AVISO(`Please fill in the Title`)
        return false
      }
      switch (editOrCreate) {
        case 'create':
          // whether the external_link contains http or https
          if (this.link === '1') {
            if (!this.form.external_link.startsWith('http://') && !this.form.external_link.startsWith('https://')) {
              this.SET_AVISO(`External ink must start with 'http://' or 'https://'`)
              return false
            }
          } else {
            if (!this.form.slug) {
              this.SET_AVISO(`Please fill in the Slug`)
              return false
            }
            if (!this.form.content) {
              this.SET_AVISO(`Please fill in the Content`)
              return false
            }
          }
          break
        case 'edit':
          if (!this.form.content) {
            this.SET_AVISO(`Please fill in the Content`)
            return false
          }
          break
        default:
          break
      }
      return true
    },
    editar (dt, index) {
      if (dt) {
        this.SET_TITULO('Edit Page')
        this.form = Object.assign({}, dt)
        this.formIndex = index
        this.form.language = this.form.language
        this.slugExists = false
        if (dt.type === 'news') {
          this.form.noticias = true
        }
        if (this.form.menu > 0) {
          this.form.menu = true
        } else {
          this.form.menu = false
        }
        if (this.form.footer_top > 0) {
          this.form.footer_top = true
        } else {
          this.form.footer_top = false
        }
        if (this.form.bottom > 0) {
          this.form.bottom = true
        } else {
          this.form.bottom = false
        }
        if (this.form.noticias > 0) {
          this.form.noticias = true
        } else {
          this.form.noticias = false
        }
        if (this.form.active > 0) {
          this.form.active = true
        } else {
          this.form.active = false
        }
        this.editMode = true
        if (this.form.external_link) this.link = '1'
      } else {
        this.SET_TITULO('Create Page')
        this.refresh()
        this.slugExists = true
        this.editMode = false
      }
      this.criar = 1
    },
    apagar (dt, index) {
      this.SET_LOAD1(true)
      this.axios.post('/pages?id=' + dt.id, { '_method': 'DELETE' }).then((res) => {
        // remove this page from the sitemap
        this.removeFieldSitemap(res.data.slug)
        // ## end ## remove this page from the sitemap
        this.res.splice(index, 1)
        this.SET_LOAD1()
        this.SET_TOAST({ msg: 'Successfully deleted' })
        this.refresh()
        this.criar = 0
      }, (er) => {
        this.SET_AVISO(er.response.data.error)
      })
    },
    refresh () {
      this.form = {
        title: '',
        slug: '',
        external_link: null,
        active: true,
        menu: true,
        bottom: true,
        footer_top: false,
        content: '',
        id: '',
        capa: '',
        language: this.$store.state.lang,
        slugExists: false,
        order_menu: 0,
        order_footer1: 0,
        order_footer2: 0
      }
      this.editorData = ''
      this.link = '0'
    },
    onFileChange (e) {
      this.SET_LOAD1(true)
      e.preventDefault()
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      let data = new window.FormData()
      data.append('image', files[0])
      this.axios.post('/multimedia', data).then((res) => {
        this.form.capa = res.data.image
        this.SET_LOAD1()
      }, (er) => {
        for (let a in er.response.data.errors) {
          this.SET_AVISO(er.response.data.errors[a])
          break
        }
      })
    },
    pais (dt, x) {
      let pais = this.paises.find(a => a.code === dt.toUpperCase())
      if (pais) {
        if (x) {
          return pais.emoji
        }
        return pais.emoji + ' ' + pais.name
      }
      return dt
    },
    handleImageAdded (file, Editor, cursorLocation, resetUploader) {
      var data = new FormData()
      data.append('image', file)
      this.axios.post('/multimedia', data).then((res) => {
        Editor.insertEmbed(cursorLocation, 'image', './../../images/' + res.data.image)
        resetUploader()
      }, (er) => {})
    },
    onChangeLink (e) {
      if (e.target.value === '1') {
        this.form.content = 'external site'
        this.form.slug = `${Math.ceil(Math.random() * 1000000)}_external`
        this.form.external_link = 'http://'
        this.form.menu = 0
      } else {
        this.form.external_link = null
        this.form.content = ''
        this.form.menu = 1
        if (this.slugExists) this.form.slug = ''
      }
    }
  }
}
</script>
